import { useState } from 'react';

import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import { FullHideIcon } from './FullHideIcon';
import { ShortHideIcon } from './ShortHideIcon';
import { SideNavIconItem } from './SideNavIconItem';
import { SideNavTextItem } from './SideNavTextItem';

interface NavbarProps {
  items: Array<{ title: string; url: string; icon: string }>;
}

export const SideNav = ({ items }: NavbarProps): JSX.Element => {
  const [isNavbarHidden, setIsNavbarHidden] = useState(false);
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });

  const handleToggleNavbar = (): void => {
    setIsNavbarHidden((prev) => !prev);
  };

  const NavItem = isNavbarHidden || isTabletOrMobile ? SideNavIconItem : SideNavTextItem;

  return (
    <div
      className={classNames(
        'navbar bg-primary-2.0 flex relative flex-shrink-0',
        isNavbarHidden ? 'w-16' : 'w-56'
      )}
    >
      <ul className="whitespace-nowrap xl:mt-8 flex flex-col justify-start flex-1 flex-grow px-2 mt-2 overflow-x-hidden overflow-y-auto">
        <div className="flex flex-col flex-1">
          {items.map((nav) => (
            <NavItem key={nav.title} title={nav.title} url={nav.url} icon={nav.icon} />
          ))}
        </div>
        <div className="mb-4">
          <button
            className={classNames('mb-4 hover:bg-transparent pl-4')}
            onClick={handleToggleNavbar}
          >
            {isNavbarHidden ? <ShortHideIcon /> : <FullHideIcon />}
          </button>
        </div>
      </ul>
    </div>
  );
};
